import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { IUserData } from "../interfaces/userData.interface";

const initialState: {
  searchedUserData: any[];
  userData: IUserData | undefined;
  userDataLoading: boolean;
} = {
  searchedUserData: [],
  userData: undefined,
  userDataLoading: false,
};

const userSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setSearchedUserData: (state, action: PayloadAction<any>) => {
      state.searchedUserData = action.payload;
    },
    setUserData: (state, action: PayloadAction<IUserData | undefined>) => {
      state.userData = action.payload;
    },
    setUserDataLoading: (state, action: PayloadAction<boolean>) => {
      state.userDataLoading = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function

// export const selectSiteData = (state: RootState) => state.siteData.data;

export const { setSearchedUserData, setUserData, setUserDataLoading } =
  userSlice.actions;

// export const getUserData = () => {
//   return async (dispatch) => {
//     try {
//       const response = await fetch("");
//       const result = await response.json();
//       console.log(result);
//       // dispatch(setUserData(result));
//     } catch (err) {
//       console.log(err);
//     }
//   };
// };

export default userSlice.reducer;
